export const copyPropertyFormField = [
	{
		type: 'select',
		title: 'Cohorts',
		placeholder: 'Select Cohort',
		formControlName: 'property',
		required: true,
		errorsMsg: [{ type: 'required', message: 'Cohort selection is required' }],
	},
];
